module.exports = __webpack_public_path__ + "static/media/BALL.89cb4785.png";